import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const InternalViewContext = React.createContext();

const InternalViewProvider = props => {
  const { children } = props;
  const [internalViewerSuppliedShopperId, setShopperIdToView] =
    useState(undefined);
  const [internalViewSuppliedOrderId, setOrderIdToView] = useState(undefined);
  const [internalViewSuppliedLineItemId, setLineItemIdToView] =
    useState(undefined);
  const [internalViewSuppliedGroupId, setGroupIdToView] = useState(undefined);

  const setInternalViewShopperId = useCallback(
    ({ shopperId }) => {
      if (shopperId !== internalViewerSuppliedShopperId)
        setShopperIdToView(shopperId);
    },
    [internalViewerSuppliedShopperId, setShopperIdToView]
  );

  const setInternalViewOrderId = useCallback(
    ({ newOrderId }) => {
      if (newOrderId !== internalViewSuppliedOrderId)
        setOrderIdToView(newOrderId);
    },
    [internalViewSuppliedOrderId, setOrderIdToView]
  );

  const setInternalViewLineItemId = useCallback(
    ({ newLineItemId }) => {
      if (newLineItemId !== internalViewSuppliedLineItemId)
        setLineItemIdToView(newLineItemId);
    },
    [internalViewSuppliedLineItemId, setLineItemIdToView]
  );

  const setInternalViewGroupId = useCallback(
    ({ newGroupId }) => {
      if (newGroupId !== internalViewSuppliedGroupId) {
        setGroupIdToView(newGroupId);
      }
    },
    [internalViewSuppliedGroupId, setGroupIdToView]
  );

  const internalViewContextValues = useMemo(
    () => ({
      internalViewerSuppliedShopperId,
      setInternalViewShopperId,
      internalViewSuppliedOrderId,
      setInternalViewOrderId,
      internalViewSuppliedLineItemId,
      setInternalViewLineItemId,
      internalViewSuppliedGroupId,
      setInternalViewGroupId,
    }),
    [
      internalViewSuppliedOrderId,
      internalViewerSuppliedShopperId,
      internalViewSuppliedLineItemId,
      setInternalViewOrderId,
      setInternalViewShopperId,
      setInternalViewLineItemId,
      internalViewSuppliedGroupId,
      setInternalViewGroupId,
    ]
  );

  return (
    <InternalViewContext.Provider value={internalViewContextValues}>
      {children}
    </InternalViewContext.Provider>
  );
};

InternalViewProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export { InternalViewContext, InternalViewProvider };
